import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingBagIcon } from 'lucide-react';
import { useCart } from '../CartContext';
export function Navbar() {
  const {
    totalItems
  } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const textColor = isHome && !scrolled ? 'text-warm' : 'text-brun';
  const navColor = isHome && !scrolled ? 'text-warm/80' : 'text-brun-soft';
  const btnClass = isHome && !scrolled ? 'border-warm/50 text-warm hover:bg-warm hover:text-brun' : 'border-brun/30 text-brun hover:bg-brun hover:text-warm';
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${scrolled || !isHome ? 'bg-warm/90 backdrop-blur-md border-b border-brun/10' : 'bg-transparent'}`} data-id="element-129" data-mp="1kyyee3ab57wy">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 md:px-10" data-id="element-130" data-mp="elptgwzg8dgm">
        <Link to="/" className="flex items-center" data-id="element-131" data-mp="jn6vwwxl07zb">
          <img src="https://cdn.magicpatterns.com/uploads/6gty9bTseeZpLTSk5XdnDS/1.png" alt="Smaken som Baken" className={`h-20 w-auto object-contain transition-all duration-500 ${isHome && !scrolled ? 'invert brightness-0 filter' // Gör loggan helt vit när den är på mörk bakgrund (hero)
        : 'mix-blend-multiply filter' // Släpper igenom den ljusa bakgrunden och behåller den mörkgrå texten när man scrollat
        }`} data-id="element-132" data-mp="om9zecxwy656" />
        </Link>

        <ul className={`hidden items-center gap-9 text-[13px] uppercase tracking-wide2 md:flex ${navColor}`} data-id="element-133" data-mp="34cczud71y5nh">
          <li data-id="element-134" data-mp="39a4rd63sbpr5"><Link to="/utbud" className="transition-opacity hover:opacity-60" data-id="element-135" data-mp="39a4sxajfnxt9">Vårt utbud</Link></li>
          <li data-id="element-136" data-mp="319gnt27lkhui"><Link to="/vision" className="transition-opacity hover:opacity-60" data-id="element-137" data-mp="3196tx3jflqjj">Vår vision</Link></li>
          <li data-id="element-138" data-mp="2wa3zse4zp4qc"><a href="/#verksamheter" className="transition-opacity hover:opacity-60" data-id="element-139" data-mp="2wa3y89pccwo8">Våra partners</a></li>
        </ul>

        <div className="flex items-center gap-4" data-id="element-140" data-mp="361zy9qazmwv3">
          <Link to="/bestall" className={`relative flex h-10 w-10 items-center justify-center rounded-full border transition-colors ${btnClass}`} data-id="element-141" data-mp="363b03kkvhujk">
            <ShoppingBagIcon className="h-4 w-4" data-id="element-142" data-mp="2de416khib2xs" />
            {totalItems > 0 && <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-terrakotta text-[9px] font-bold text-warm" data-id="element-143" data-mp="2sb4o8aor69px">
                {totalItems}
              </span>}
          </Link>
          <Link to="/bestall" className={`hidden rounded-full border px-5 py-2 text-[12px] uppercase tracking-wide2 transition-colors md:block ${btnClass}`} data-id="element-144" data-mp="7it09tlig0cw">
            Gör förfrågan
          </Link>
        </div>
      </nav>
    </header>;
}